import { CancelledError } from "../core/errors.js";

export function throwIfAborted(signal: AbortSignal | undefined): void {
  if (signal?.aborted) throw new CancelledError({ cause: signal.reason });
}

export async function sleep(ms: number, signal: AbortSignal | undefined): Promise<void> {
  return new Promise((resolve, reject) => {
    if (signal?.aborted) {
      reject(new CancelledError({ cause: signal.reason }));
      return;
    }
    const timer = setTimeout(() => {
      signal?.removeEventListener("abort", onAbort);
      resolve();
    }, ms);
    const onAbort = (): void => {
      clearTimeout(timer);
      reject(new CancelledError({ cause: signal?.reason }));
    };
    signal?.addEventListener("abort", onAbort, { once: true });
  });
}
